export const getIObserverControllerSettings = (state) => state.common.iObserverSettingsController;

export const getIObserverControllerWsAddresses = (state) => {
  const { iObserverSettingsController } = state.common;
  if (iObserverSettingsController && iObserverSettingsController.value !== undefined) {
    return iObserverSettingsController.value;
  }
  return '';
};
